// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_5h-0";
export var eligibilityCardNotEligible = "_5h-1";